import ErrorPage from "../../pages/ErrorPage/component";
const MaybeError = ({ children, statusCode = 200, polopolyId }) => {
    // 2xx
    const hasError = ((statusCode / 100) | 0) !== 2;
    return hasError ? (
        <ErrorPage statusCode={statusCode} polopolyId={polopolyId} />
    ) : (
        children
    );
};

export default MaybeError;
